import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

@JsonApiModelConfig({
  type: 'mandatory_training_information_settings',
})
export class MandatoryTrainingInformationSetting extends JsonApiModel {
  @Attribute({ serializedName: 'content' })
  content!: string;

  @Attribute()
  language!: string;
}
